"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _isHtmlEvent = _interopRequireDefault(require("@active/react-utils/eventHandler/isHtmlEvent"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _compact = _interopRequireDefault(require("lodash/fp/compact"));
var _reduce = _interopRequireDefault(require("lodash/fp/reduce"));
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _merge = _interopRequireDefault(require("lodash/fp/merge"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _isBoolean = _interopRequireDefault(require("lodash/fp/isBoolean"));
var _isObject = _interopRequireDefault(require("lodash/fp/isObject"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _negate = _interopRequireDefault(require("lodash/fp/negate"));
var _validate = require("@active/core/userInput/validate");
var _utils = require("../Form/utils");
var _FormFieldError = _interopRequireDefault(require("../FormFieldError"));
var _FormFieldWarning = _interopRequireDefault(require("./FormFieldWarning"));
var _FormFieldWrapper = _interopRequireDefault(require("./FormFieldWrapper"));
var _excluded = ["fieldClassName", "inputId", "labelId", "errorId", "error", "touched", "name", "trimInput", "as", "required", "value", "valueProp", "hasValue", "setFieldValue", "setFieldTouched", "registerField", "unregisterField", "validate", "innerRef", "htmlForm", "hint", "requiredError", "invalidError", "warning", "onChange", "onBlur", "children", "subscribedFields", "validateField", "suppressErrorMsg", "renderError"];
/* eslint @typescript-eslint/no-explicit-any: off */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var warningIdFor = function warningIdFor() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(name, "-warning");
};
var hintIdFor = function hintIdFor() {
  var inputId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return "".concat(inputId, "-hint");
};
var getLabelledby = function getLabelledby() {
  var labelledby = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _filter["default"])(function (item) {
    return !!item;
  })(labelledby).join(' ') || undefined;
};
var eitherExist = function eitherExist(defaultValue) {
  return function (value) {
    return value !== undefined ? value : defaultValue;
  };
};
var applyMessage = function applyMessage(msg) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(internal) {
      var internalMsg;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return internal;
          case 2:
            internalMsg = _context.sent;
            return _context.abrupt("return", internalMsg ? msg || internalMsg : null);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var requiredCheck = function requiredCheck(value) {
  return !(0, _validate.hasInput)(value) ? 'react-ui.validation.required' : undefined;
};
var parseValidator = function parseValidator(validator) {
  if (typeof validator === 'function') {
    return {
      invalid: validator
    };
  }
  return validator;
};
var calculateError = function calculateError(error, touched) {
  return (0, _isObject["default"])(error) ? (0, _mapValues["default"])(error, function (inputError, key) {
    return (0, _utils.hasFieldError)(inputError, (0, _isBoolean["default"])(touched) ? touched : touched === null || touched === void 0 ? void 0 : touched[key]);
  }) : (0, _utils.hasFieldError)(error, touched);
};
var mergeCompositeResults = function mergeCompositeResults(results) {
  var res = (0, _reduce["default"])(function (pre, cur) {
    return (0, _merge["default"])(cur)(pre);
  }, {})((0, _compose["default"])(_compact["default"], (0, _filter["default"])(_isObject["default"]))(results));
  return (0, _utils.isErrorEmpty)(res) ? '' : res;
};
var FormFieldPresenter = function FormFieldPresenter(_ref2) {
  var _AsElement$defaultPro;
  var fieldClassName = _ref2.fieldClassName,
    inputId = _ref2.inputId,
    labelId = _ref2.labelId,
    errorId = _ref2.errorId,
    error = _ref2.error,
    touched = _ref2.touched,
    name = _ref2.name,
    globalTrimInput = _ref2.trimInput,
    AsElement = _ref2.as,
    _ref2$required = _ref2.required,
    required = _ref2$required === void 0 ? false : _ref2$required,
    value = _ref2.value,
    valueProp = _ref2.valueProp,
    hasValue = _ref2.hasValue,
    setFieldValue = _ref2.setFieldValue,
    setFieldTouched = _ref2.setFieldTouched,
    registerField = _ref2.registerField,
    unregisterField = _ref2.unregisterField,
    externalValidate = _ref2.validate,
    innerRef = _ref2.innerRef,
    htmlForm = _ref2.htmlForm,
    hint = _ref2.hint,
    requiredError = _ref2.requiredError,
    invalidError = _ref2.invalidError,
    warning = _ref2.warning,
    externalOnChange = _ref2.onChange,
    externalOnBlur = _ref2.onBlur,
    children = _ref2.children,
    subscribedFields = _ref2.subscribedFields,
    validateField = _ref2.validateField,
    suppressErrorMsg = _ref2.suppressErrorMsg,
    renderError = _ref2.renderError,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var field = (0, _react.useRef)({});
  var fieldValidate = (0, _react.useMemo)(function () {
    return {
      required: requiredCheck
    };
  }, []);
  var hintId = hint && hintIdFor(inputId);
  var warningId = warning && warningIdFor(name);
  var labelledby = getLabelledby([labelId, hintId]);
  var isInitialRender = (0, _react.useRef)(true);
  var fieldValue = (0, _compose["default"])(eitherExist(''), eitherExist((_AsElement$defaultPro = AsElement.defaultProps) === null || _AsElement$defaultPro === void 0 ? void 0 : _AsElement$defaultPro.initialValue))(value);
  var valueBinding = (0, _defineProperty2["default"])({}, valueProp !== null && valueProp !== void 0 ? valueProp : 'value', fieldValue);
  var hasError = (0, _react.useMemo)(function () {
    return calculateError(error, touched);
  }, [error, touched]);
  var onChange = (0, _react.useCallback)(function (v, touchField) {
    touchField && !touched && (setFieldTouched === null || setFieldTouched === void 0 ? void 0 : setFieldTouched(name, true));
    setFieldValue === null || setFieldValue === void 0 || setFieldValue((0, _isHtmlEvent["default"])(v) ? (0, _prop["default"])('target.name')(v) : name, (0, _isHtmlEvent["default"])(v) ? (0, _prop["default"])('target.value')(v) : v);
    externalOnChange && externalOnChange(v);
  }, [name, setFieldValue, externalOnChange, setFieldTouched, touched]);
  var onBlur = (0, _react.useCallback)(function (e) {
    var _e$target;
    setFieldTouched === null || setFieldTouched === void 0 || setFieldTouched((e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.name) || name, true);
    externalOnBlur === null || externalOnBlur === void 0 || externalOnBlur(e);
  }, [name, setFieldTouched, externalOnBlur]);
  var onTouched = (0, _react.useCallback)(function (e) {
    var _e$target2;
    var inputName = (0, _isString["default"])(e) ? e : e === null || e === void 0 || (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.name;
    setFieldTouched === null || setFieldTouched === void 0 || setFieldTouched(inputName || name, true);
  }, [name, setFieldTouched]);
  var registerValidate = (0, _react.useCallback)(function (validator) {
    Object.assign(fieldValidate, parseValidator(validator));
  }, [fieldValidate]);
  (0, _react.useEffect)(function setupFieldConfig() {
    field.current.config = AsElement.formFieldConfig;
  }, [AsElement]);
  (0, _react.useEffect)(function setupFieldValidation() {
    field.current.validate = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(v) {
        var _field$current;
        var useTrim, trimValue, requiredFn, invalidFn, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              useTrim = globalTrimInput && !((_field$current = field.current) !== null && _field$current !== void 0 && (_field$current = _field$current.config) !== null && _field$current !== void 0 && _field$current.doNotTrimValue);
              trimValue = useTrim ? (0, _utils.trimAny)(v) : v;
              requiredFn = fieldValidate.required, invalidFn = fieldValidate.invalid;
              _context2.next = 5;
              return Promise.all([required ? applyMessage(requiredError)(requiredFn(trimValue)) : undefined, invalidFn && applyMessage(invalidError)(invalidFn(trimValue)), externalValidate && externalValidate(trimValue, subscribedFields !== null && subscribedFields !== void 0 ? subscribedFields : {})]);
            case 5:
              result = _context2.sent;
              return _context2.abrupt("return", mergeCompositeResults(result) || (0, _compose["default"])(_first["default"], _compact["default"], (0, _filter["default"])((0, _negate["default"])(_isObject["default"])))(result));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
  }, [fieldValidate, externalValidate, invalidError, required, requiredError, subscribedFields, globalTrimInput]);
  (0, _react.useEffect)(function () {
    registerField === null || registerField === void 0 || registerField(name, field.current);
    return function () {
      unregisterField === null || unregisterField === void 0 || unregisterField(name);
    };
  });
  (0, _react.useEffect)(function () {
    function needToUpdateErrorMsg() {
      return _needToUpdateErrorMsg.apply(this, arguments);
    }
    function _needToUpdateErrorMsg() {
      _needToUpdateErrorMsg = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _field$current$valida, _field$current2;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = hasError;
              if (!_context3.t0) {
                _context3.next = 9;
                break;
              }
              _context3.t1 = JSON;
              _context3.next = 5;
              return (_field$current$valida = (_field$current2 = field.current).validate) === null || _field$current$valida === void 0 ? void 0 : _field$current$valida.call(_field$current2, value);
            case 5:
              _context3.t2 = _context3.sent;
              _context3.t3 = _context3.t1.stringify.call(_context3.t1, _context3.t2);
              _context3.t4 = JSON.stringify(error);
              _context3.t0 = _context3.t3 !== _context3.t4;
            case 9:
              return _context3.abrupt("return", _context3.t0);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _needToUpdateErrorMsg.apply(this, arguments);
    }
    function updateChangedErrorMsg() {
      return _updateChangedErrorMsg.apply(this, arguments);
    }
    function _updateChangedErrorMsg() {
      _updateChangedErrorMsg = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return needToUpdateErrorMsg();
            case 2:
              if (!_context4.sent) {
                _context4.next = 4;
                break;
              }
              validateField === null || validateField === void 0 || validateField(name);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _updateChangedErrorMsg.apply(this, arguments);
    }
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    updateChangedErrorMsg();
  }, [
  // eslint-disable-line react-hooks/exhaustive-deps
  invalidError, requiredError, externalValidate, name, validateField]);
  (0, _react.useEffect)(function () {
    if (subscribedFields) {
      validateField === null || validateField === void 0 || validateField(name);
    }
  }, [name, subscribedFields, validateField]);
  (0, _react.useEffect)(function () {
    if (!hasValue) {
      setFieldValue === null || setFieldValue === void 0 || setFieldValue(name, fieldValue, false);
    }
  }, [setFieldValue, name, fieldValue, hasValue]);
  return /*#__PURE__*/_react["default"].createElement(_FormFieldWrapper["default"], {
    className: fieldClassName
  }, typeof AsElement === 'string' ? /*#__PURE__*/_react["default"].createElement(AsElement, _objectSpread(_objectSpread(_objectSpread({
    name: name,
    id: inputId,
    'aria-labelledby': labelledby,
    'aria-describedby': errorId || warningId,
    'aria-required': required,
    'aria-invalid': hasError || undefined,
    onBlur: onBlur,
    onChange: onChange
  }, valueBinding), (0, _utils.omitFormProps)(props)), {}, {
    form: htmlForm,
    ref: innerRef
  }), children) : /*#__PURE__*/_react["default"].createElement(AsElement, (0, _extends2["default"])({
    name: name,
    id: inputId,
    "aria-labelledby": labelledby,
    "aria-describedby": errorId || warningId,
    "aria-required": required,
    "aria-invalid": hasError || undefined,
    hasError: hasError,
    hasWarning: !!warning,
    onChange: onChange,
    onBlur: onBlur,
    registerValidate: registerValidate,
    ref: innerRef,
    required: required,
    onTouched: onTouched
  }, valueBinding, htmlForm ? {
    htmlForm: htmlForm
  } : {}, {
    isinform: "true"
  }, props), children), !suppressErrorMsg && /*#__PURE__*/_react["default"].createElement(_FormFieldError["default"], {
    name: name,
    renderError: renderError
  }), warning && /*#__PURE__*/_react["default"].createElement(_FormFieldWarning["default"], {
    id: warningId
  }, warning), hint && /*#__PURE__*/_react["default"].createElement("div", {
    id: hintId,
    className: "form-help-text"
  }, hint));
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FormFieldPresenter);